// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"453":"053154ee","733":"d229b3e8","853":"5a074b93","5529":"3ba07506"}[chunkId] + ".chunk.css";
};